import { instance } from './axios';
import _ from 'lodash';

const getErrorMessage = (error) => _.get(error, 'response.data.message');

export async function listModelPortfolios() {
  try {
    const result = await instance.get('/model-portfolios').then((res) => res.data);

    return [result, null];
  } catch (err) {
    return [null, getErrorMessage(err)];
  }
}
